export default "__VITE_ASSET__DD2_JKZK__"